import { useEffect, useId, useState } from "react";
import { Link } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import {
  getDemoPersonaId,
  getDemoPersonas,
  setDemoPersona,
  supabase,
} from "@/lovable-demo/runtime/client";
import { Button } from "@/components/ui/button";

export function AccountBar() {
  const queryClient = useQueryClient();
  const controlId = useId();
  const [personaId, setPersonaId] = useState(getDemoPersonaId);
  const personas = getDemoPersonas();
  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange(() => setPersonaId(getDemoPersonaId()));
    return () => data.subscription.unsubscribe();
  }, []);
  return (
    <div className="mt-3 space-y-2 border-t border-sidebar-border pt-3">
      <label htmlFor={controlId} className="block text-xs font-medium">
        Synthetic demo persona
      </label>
      <select
        id={controlId}
        value={personaId ?? ""}
        className="w-full rounded border border-input bg-background px-2 py-1.5 text-xs"
        onChange={async (event) => {
          setDemoPersona(event.target.value);
          setPersonaId(getDemoPersonaId());
          await queryClient.invalidateQueries();
        }}
      >
        {personas.map((persona) => (
          <option key={persona.id} value={persona.id}>
            {persona.name} · {persona.roles.join(", ")}
          </option>
        ))}
      </select>
      <p className="text-[0.65rem] text-muted-foreground">
        Simulates workflow authority in this demo session. Your portal account and permissions stay
        unchanged.
      </p>
      <SignOutButton />
    </div>
  );
}

/** Source-compatible name: leaving the demo never signs out the portal. */
export function SignOutButton() {
  return (
    <Button variant="outline" size="sm" asChild>
      <Link to="/">
        <ArrowLeft className="size-3.5" /> Back to portal
      </Link>
    </Button>
  );
}
